import { IProgram } from "../interfaces";
import { IFragment } from "../interfaces/fragment";
import { IAllChallengeLayouts } from "../interfaces/program-fragments";

export const useProgramNudgeFragmentManager = (
  program: IProgram,
  fragment: { rootId: string }
): [typeof rootId, typeof root, typeof selectedFragment] => {
  let selectedFragment: IFragment<IAllChallengeLayouts> = null;

  if (program && program.layout && program.layout.programLayout) {
    selectedFragment = program.layout.programLayout.nudge;
  }

  let root: IAllChallengeLayouts = null;
  let rootId: string = null;
  if (selectedFragment) {
    rootId = selectedFragment.rootId;
    if (fragment && fragment.rootId) rootId = fragment.rootId;
    root = selectedFragment.byId[rootId];
  }
  return [rootId, root, selectedFragment];
};
